<template lang="html">
  <div class="home-hero">
    <div class="home-hero-mobile-bg">
      <slot name="hero-image-mobile"> </slot>
    </div>
    <div class="home-hero-desktop-bg">
      <slot name="hero-image-desktop"> </slot>
    </div>
    <div class="home-hero-text">
      <h5><slot name="hero-text-subtitle"> </slot></h5>
      <h1><slot name="hero-text-title"> </slot></h1>
    </div>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .home-hero {
    min-height: 100vh;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns:  repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
  }
  .home-hero-mobile-bg {
    grid-column: 1/13;
    grid-row: 1/13;
    z-index:2;
  }
  .home-hero-desktop-bg {
    display: none;
  }
  .home-hero-text {
    padding-top: 1em;
    grid-column: 2/12;
    grid-row:6;
    text-align: left;
    z-index: 3;
  }

  @media (min-width: 768px) {
    .home-hero-mobile-bg {
      display: none;
    }

    .home-hero-desktop-bg {
      display:block;
      grid-column: 1/13;
      grid-row: 3/13;
      z-index:2;
      margin-right: -2em;
    }
    .home-hero-text {
      padding-top: 1em;
      grid-column: 2/8;
      grid-row:6;
    }
  }
  @media (min-width: 992px) {
      .home-hero {
        min-height: 50vh;
        margin-bottom: 3em;
      }
      .home-hero-desktop-bg {
        grid-column: 4/13;
        grid-row: 1/13;
        z-index:2;
        margin-top: -3em;
        margin-right: 0;
      }
      .home-hero-text {
        padding-top: 1em;
        grid-column: 2/8;
        grid-row:4/10;
      }
      .home-hero-text h1 {
        font-size: 4rem;
      }
   }
   @media (min-width: 1440px) {
       .home-hero-desktop-bg {
         grid-column: 6/12;
         grid-row: 1/13;
         z-index:2;
         margin-top: -5em;
       }
       .home-hero-text {
         padding-top: 1em;
         grid-column: 2/8;
         grid-row:6;
       }
       .home-hero-text h1 {
         font-size: 5rem;
       }
    }

</style>
